import { render, staticRenderFns } from "./modalBack.vue?vue&type=template&id=bc1df3c6&"
import script from "./modalBack.vue?vue&type=script&lang=ts&"
export * from "./modalBack.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports